import { render } from "./workflowcard-item.vue?vue&type=template&id=6973d07e"
import script from "./workflowcard-item.vue?vue&type=script&lang=js"
export * from "./workflowcard-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__